<template>
  <v-card class="d-flex flex-column h-100" elevation="2" hover>
    <v-card-title class="justify-space-between text-subtitle-1 py-2">
      <v-text-field
        v-if="editName && isLocal"
        outlined
        height="15px"
        append-icon="mdi-close"
        prepend-inner-icon="mdi-check"
        dense
        hide-details
        :disabled="loadingName"
        v-model="editNameText"
        :loading="loadingName"
        @click:prepend-inner="updateTitleName()"
        @click:append="editName = false"
      ></v-text-field>

      <span
        v-else
        class="text-truncate"
        style="max-width: 85%"
        :title="video.title"
      >
        <v-icon
          v-if="isLocal"
          @click="
            editName = true;
            editNameText = video.title;
          "
          size="15"
          class="ml-1"
          >mdi-pencil</v-icon
        >
        {{ video.title || "بدون نام" }}
      </span>
      <v-checkbox
        v-if="Selectable"
        :input-value="value"
        class="pa-0 ma-0"
        color="success"
        dense
        hide-details
        readonly
      />
    </v-card-title>

    <div class="iframe-wrapper">
      <iframe
        v-if="!isLocal"
        :src="videoLink"
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        "
        allow="encrypted-media; fullscreen"
        allowfullscreen
      ></iframe>

      <video
        v-else
        :src="videoLink"
        controls
        :autoplay="false"
        preload="metadata"
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        "
      ></video>
    </div>

    <v-card-actions
      class="d-flex flex-wrap justify-start align-center mt-auto py-1 px-2 cover"
    >
      <span
        :title="video.description"
        class="text-truncate"
        style="max-width: 80%"
      >
        {{ video.description }}
      </span>
      <div class="d-flex align-center pl-2">
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="info"
              v-bind="attrs"
              v-on="on"
              @click.stop="$emit('copy', videoLink)"
            >
              <v-icon small>mdi-link-variant</v-icon>
            </v-btn>
          </template>
          <span>کپی لینک</span>
        </v-tooltip> -->

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click.stop="$emit('open', videoLink)"
            >
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <span>باز کردن</span>
        </v-tooltip> -->

        <v-tooltip bottom v-if="isLocal">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="success"
              v-bind="attrs"
              v-on="on"
              @click.stop="$emit('download', videoLink)"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>دانلود</span>
        </v-tooltip>
      </div>

      <v-btn
        v-if="isLocal"
        :loading="loading"
        icon
        small
        color="red"
        @click.stop="$emit('delete', video.id)"
      >
        <v-icon small>mdi-trash-can</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "videoSelectorCard",

  props: {
    value: Boolean,
    video: Object,
    loading: Boolean,
    isLocal: {
      type: Boolean,
      default: false,
    },
    Selectable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editName: false,
      editNameText: "",
      loadingName: false,
    };
  },
  computed: {
    videoLink() {
      return this.isLocal ? this.video.full_path : this.video.file_link;
    },
  },
  methods: {
    updateTitleName() {
      this.loadingName = true;
      const local_url = this.$robotApi;
      this.$api
        .put(`${local_url}/files/update/${this.video.id}`, {
          title: this.editNameText,
        })
        .then(() => {
          this.$toast.success("نام با موفقیت بروزرسانی شد");
          this.editName = false;
          // بروزرسانی نام به صورت محلی در کامپوننت فرزند (یا ارسال به پدر)
          this.$emit("title-updated", this.editNameText);
          // چون شیء از پدر آمده، مستقیما در ویو آپدیت می‌شود
          this.video.title = this.editNameText;
        })
        .catch(() => {
          this.$toast.error("خطا در بروزرسانی نام");
        })
        .finally(() => (this.loadingName = false));
    },
  },
};
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}
.bg-light {
  background-color: #f9f9f981;
}
.iframe-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background-color: #000;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.cover {
  height: 30px;
  background: #d3d1d14d !important;
  border-radius: 5px !important;
}
</style>
